export default __webpack_public_path__ + "static/media/Welcome-Stroop.b53b0f07.svg";